
<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Kelime Ekle/Güncelle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">

      <div class="form-group">
        <label>Kelime</label>

        <input type="text" formControlName="word" class="form-control">
      </div>

      <div class="form-group">
        <label>Anlamı</label>

        <input type="text" formControlName="translate" class="form-control">
      </div>

      <div class="form-group">
        <label>Kodu <small>*ingilizce karşılığı</small></label>

        <input type="text" formControlName="code" class="form-control">
      </div>
      <div class="form-group">
        <label>Tipi</label>
        <select formControlName="type" class="form-control">
          <option *ngFor="let tt of keywordTypes" [value]="tt.name">{{tt.name}}</option>
          <!-- <option value="NOUN">NOUN</option>
      <option value="PRONOUN">PRONOUN</option>
      <option value="WERB">WERB</option>
      <option value="ADJECTIVE">ADJECTIVE</option>
      <option value="ADVERB">ADVERB</option>
      <option value="PREPOSITION">PREPOSITION</option>
      <option value="CONJUNCTION">CONJUNCTION</option>
      <option value="INTERJECTION">INTERJECTION</option> -->
        </select>
      </div>

      <div class="form-group">
        <label>Kategori</label>

        <input type="text" formControlName="category" class="form-control">
      </div>

      <div class="form-group">
        <label>Video</label>

        <input type="text" formControlName="youTube" class="form-control">
      </div>

      <div class="form-group">
        <label>Örnek Cümle <button (click)="getSampleSentence()" class="btn btn-primary">Apiden çek</button></label>

        <input type="text" formControlName="sentence" class="form-control">
      </div>
      <div class="form-group">
        <label>Örnek Cümle Çevirisi</label>

        <input type="text" formControlName="translatedSentence" class="form-control">
      </div>

      <div class="form-group">
        <label>Sıra</label>

        <input type="number" formControlName="order" class="form-control">
      </div>

      <div class="form-group">
        <label> <input type="checkbox" formControlName="isPremium"> Premium</label>


      </div>

      <div class="form-group">
        <label> <input type="checkbox" formControlName="hasWallpaper"> Duvar kağıdı olsun mu?</label>


      </div>


      <!-- <div class="form-group">
    <label>Soru Tipi</label>

    <select formControlName="questionType" class="form-control">
      <option value="1">Kelime öğrenilen dil şıklar ana dil</option>
      <option value="2">Kelime ana dil şıklar öğrenilen dil</option>
      <option value="3">Boşluk doldurma</option>
    </select>
  </div> -->

      <div class="form-group">
        <label>Seçenek1</label>

        <input type="text" formControlName="option1" class="form-control">
      </div>

      <div class="form-group">
        <label>Seçenek2</label>

        <input type="text" formControlName="option2" class="form-control">
      </div>

      <div class="form-group">
        <label>Seçenek3</label>

        <input type="text" formControlName="option3" class="form-control">
      </div>

      <div class="form-group">
        <label>Seçenek 1 Anadil</label>

        <input type="text" formControlName="optionMother1" class="form-control">
      </div>

      <div class="form-group">
        <label>Seçenek 2 Anadil</label>

        <input type="text" formControlName="optionMother2" class="form-control">
      </div>

      <div class="form-group">
        <label>Seçenek 3 Anadil</label>

        <input type="text" formControlName="optionMother3" class="form-control">
      </div>



      <div class="row mt-2">
        <div class="col-md-12">
          <h4>İkon <div *ngIf="data"><img src="{{data.icon}}" width="100"></div></h4>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="SelectSingleFile($event)">
            <ngx-dropzone-label>
              <div class="dz-default dz-message">
                <span class="dz-default">Dosyayı buraya sürükleyin yada seçmek için tıklayın<br />Lütfen png yada jpg Dosyası yükleyin</span>
              </div>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="SinglefileonRemove(f)">
              <ngx-dropzone-label class="dropzone1 text-center">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-image-preview>
          </div>



        </div>
      </div>

      <div class="form-group">
        <label> <input type="checkbox" formControlName="hasText"> Duvar kağıdı yazılı mı?</label>


      </div>

      <div class="row mt-2">
        <div class="col-md-12">
          <h4>Duvar Kağıdı <div *ngIf="data"><img src="{{data.wallpaper}}" width="100"></div></h4>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="SelectSingleFileWallpaper($event)">
            <ngx-dropzone-label>
              <div class="dz-default dz-message">
                <span class="dz-default">Dosyayı buraya sürükleyin yada seçmek için tıklayın<br />Lütfen png yada jpg Dosyası yükleyin</span>
              </div>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of fileswallpaper" [file]="f" [removable]="true" (removed)="SinglefileonRemovewallpaper(f)">
              <ngx-dropzone-label class="dropzone1 text-center">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-image-preview>
          </div>



        </div>
      </div>

      <div class="form-group">
        <label> <input type="checkbox" formControlName="premiumHasText">Premium Duvar kağıdı yazılı mı?</label>


      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <h4>Premium Duvar Kağıdı <div *ngIf="data"><img src="{{data.premiumWallpaper}}" width="100"></div></h4>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="SelectSingleFilePremiumWallpaper($event)">
            <ngx-dropzone-label>
              <div class="dz-default dz-message">
                <span class="dz-default">Dosyayı buraya sürükleyin yada seçmek için tıklayın<br />Lütfen png yada jpg Dosyası yükleyin</span>
              </div>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of filespremiumwallpaper" [file]="f" [removable]="true" (removed)="SinglefileonRemovepremiumwallpaper(f)">
              <ngx-dropzone-label class="dropzone1 text-center">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-image-preview>
          </div>



        </div>
      </div>


      <div class="row mt-2">
        <div class="col-md-12">
          <h4>Lisans <div *ngIf="data"><img src="{{data.licence}}" width="100"></div></h4>
          <div class="custom-dropzone" ngx-dropzone [accept]="'application/pdf'" (change)="SelectSingleFileLicence($event)">
            <ngx-dropzone-label>
              <div class="dz-default dz-message">
                <span class="dz-default">Dosyayı buraya sürükleyin yada seçmek için tıklayın<br />Lütfen pdf Dosyası yükleyin</span>
              </div>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of fileslicences" [file]="f" [removable]="true" (removed)="SinglefileonRemovelicence(f)">
              <ngx-dropzone-label class="dropzone1 text-center">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-image-preview>
          </div>



        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>
    </div>
  </form>
</div>

